import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface IUseRedirectObj {
  href: string;
  asPath: string;
  shallow: boolean;
}

/**
 * A hook to redirect
 */
export const useRedirect = (condition: boolean, redirectObject: IUseRedirectObj) => {
  const router = useRouter();
  const [{ href, shallow, asPath }] = useState(() => redirectObject);

  useEffect(() => {
    if (condition) {
      router.push(href, asPath, { shallow });
    }
  }, [asPath, condition, href, router, shallow]);
};
